import React from 'react';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import Divider from 'app/components/bibs/shared/Divider';
import { catalogBibShape, ugcVideoShape, libraryShape } from '@bibliocommons/bc-prop-types';
import { VideoDisplayContainer } from 'app/components/bibs/shared/ugc/VideoDisplay';
import BibSubPage from 'app/components/bibs/subpages/BibSubPage';
import CommunityDisclaimer from 'app/components/bibs/shared/ugc/CommunityDisclaimer';

import './VideoPage.scss';

export class VideoPage extends React.PureComponent {
  componentDidMount() {
    this.fetchRelationships();
  }

  fetchRelationships() {
    const { currentUserId, relationshipsActions, video } = this.props;
    const authorUserId = video.get('userId', null);

    if (currentUserId && authorUserId) {
      relationshipsActions.getRelationships({ userId: currentUserId, userIds: Immutable.List([authorUserId]) });
    }
  }

  renderUgcDisclaimer() {
    const { currentLibrary } = this.props;
    return (
      currentLibrary?.get('ugcDisclaimerMessageEnabled') && (
        <CommunityDisclaimer type="videos" currentLibrary={currentLibrary} />
      )
    );
  }

  render() {
    const { video, catalogBib } = this.props;

    return (
      <div className="cp-video-page">
        <BibSubPage catalogBib={catalogBib} headerLocKey="video">
          <Divider />
          {this.renderUgcDisclaimer()}
          <VideoDisplayContainer
            video={video}
            key={video.get('id')}
            displayStaffBadge={false}
            catalogBib={catalogBib}
          />
        </BibSubPage>
      </div>
    );
  }
}

VideoPage.propTypes = {
  catalogBib: catalogBibShape.isRequired,
  currentUserId: PropTypes.number,
  relationshipsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  video: ugcVideoShape.isRequired,
  currentLibrary: libraryShape.isRequired
};

export default VideoPage;
